import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { ArchivedSubmissionError, fetchMyFormSubmissionDetail } from "../api/publicFormsApi";
import PublicForm from "./PublicForm";
import { Alert, AlertDescription } from "@/components/ui/alert";

const PublicFormSubmissionView = () => {
  const { formToken, uid } = useParams<{ formToken: string; uid: string }>();
  const [data, setData] = useState<Record<string, unknown> | null>(null);
  const [relationDisplay, setRelationDisplay] = useState<Record<string, string> | undefined>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [archivedBlocked, setArchivedBlocked] = useState(false);

  useEffect(() => {
    if (!formToken || !uid) {
      setError("Missing form or submission.");
      setArchivedBlocked(false);
      setLoading(false);
      return;
    }
    setLoading(true);
    setError(null);
    setArchivedBlocked(false);
    fetchMyFormSubmissionDetail(formToken, uid)
      .then((detail) => {
        const base =
          detail.data && typeof detail.data === "object" ? ({ ...detail.data } as Record<string, unknown>) : {};
        setData(base);
        setRelationDisplay(detail.relationDisplay);
        setError(null);
        setArchivedBlocked(false);
      })
      .catch((err: unknown) => {
        setData(null);
        if (err instanceof ArchivedSubmissionError) {
          setArchivedBlocked(true);
          setError(err.message);
          return;
        }
        setArchivedBlocked(false);
        setError(err instanceof Error ? err.message : "Failed to load submission");
      })
      .finally(() => setLoading(false));
  }, [formToken, uid]);

  if (loading) {
    return (
      <div className="flex items-center justify-center w-full min-h-[40vh]">
        <p className="text-sm text-gray-500 dark:text-gray-400">Loading...</p>
      </div>
    );
  }
  if (error || !data) {
    return (
      <div className="p-6 max-w-lg mx-auto">
        <Alert variant={archivedBlocked ? "default" : "destructive"} className={archivedBlocked ? "border-red-300 bg-red-50 text-red-900 dark:border-red-900 dark:bg-red-950/50 dark:text-red-100" : undefined}>
          <AlertDescription>{error ?? "Submission not found."}</AlertDescription>
        </Alert>
      </div>
    );
  }
  return (
    <PublicForm
      formToken={formToken}
      initialData={data as Record<string, any>}
      readOnly
      ownerSubmissionUid={uid}
      relationDisplay={relationDisplay}
    />
  );
};

export default PublicFormSubmissionView;
